<template>
    <el-container>
        <el-main >
            <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top">
                <el-row >
                    <el-col :span="5" v-if="orgType == 1">
                        <el-form-item label="机构" prop="org" class="cls-col">
                            <el-select size="small" placeholder="机构" v-model="searchData.orgCode" clearable @change="changeOrg" style="margin-right: 10px; width: 100%">
                                <el-option v-for="o in organizationData" :label="o.organizationName" :value="o.orgCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="消息类别" prop="categoryId" class="cls-col">
                           <el-select v-model="searchData.categoryId" placeholder="消息类别" size="small" style="width: 100%" clearable>
                               <el-option
                                v-for="item in categoryData"
                                :key="item.categoryName"
                                :label="item.categoryName"
                                :value="item.categoryId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="发送范围" prop="scope" class="cls-col">
                            <el-select v-model="searchData.scope" placeholder="发送范围" style="width: 100%" size="small" clearable>
                                <el-option label="所有注册用户" :value="1"></el-option>
                                <el-option label="按课程分类发送" :value="2"></el-option>
                                <el-option label="按课程内容发送" :value="3"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="内容" prop="content" class="cls-col">
                            <el-input v-model="searchData.content" placeholder="内容" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item >
                    <el-button type="primary" plain size="small" icon="el-icon-search" @click="search()">查询</el-button>
                </el-form-item>
            </el-form>
            <el-button type="success" icon="el-icon-circle-plus-outline" size="small" round @click="addMessage" class="but-cls">添加</el-button>
            <el-button type="danger" icon="el-icon-delete" size="small" round @click="deleteMessageMore" class="but-cls">删除</el-button>
            <el-table
                    :data="messageData"
                    border
                    @selection-change="handleSelectionChange"
                    highlight-current-row
                    style="width: 100%">
                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column
                        type="index"
                        label="序号"
                        width="50"
                        fixed="left"
                >
                </el-table-column>
                 <el-table-column
                     prop="content"
                        label="消息内容"
                        width="200"
                >
                    <template slot-scope="scope">
                        <div v-html="scope.row.content"></div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="organizationName"
                    label="所属机构"
                >
                </el-table-column>
                <el-table-column
                        prop="categoryName"
                        label="消息类别"
                        >
                </el-table-column>
                 <!-- <el-table-column
                        prop="orgCode"
                        :formatter="f_orgCode"
                        label="所属机构"
                        >
                </el-table-column> -->
                <el-table-column
                        prop="scope"
                        :formatter="f_scope"
                        label="发送范围"
                        >
                </el-table-column>
                <el-table-column
                        prop="createTime"
                        label="创建时间"
                        :formatter="dateFormat"
                        width="200"
                >
                </el-table-column>    
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="200"
                >
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="updateMessage(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" @click="sendMessageToStudent(scope.row)">发送指定用户</el-button>
                        <el-button @click="deleteMessage(scope.$index, scope.row)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="pageSize"
                    :current-page.sync="currentPage"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    style="margin-top: 10px; float: right; margin-right: 10px">
            </el-pagination>
        </el-main>
    </el-container>
</template>

<script>
    import https from '@/https.js'
    import {dateFormat,monthFormat} from '@/api/utils.js'

    const formData = {};
    export default {
        data() {
            return {
                  //分页相关
                pageSize:10,
                total: 0,
                currentPage: 1,
                orgType: "",
                org: [],
                formData: JSON.parse(JSON.stringify(formData)),
                messageData: [],
                searchData: {
                    size: 10,
                    page: 1,
                    orgCode: "",
                    content: "",
                    categoryId: "",
                    messageId:"",
                    scope:""
                },
                categoryData:[],
                showEdit: [],
              

                multipleSelection: [],
                organizationData:[]
            }
        },
        methods: {
              selectOrg() {
                https.fetchGet('/managerOrganization/getOrganizationList', '', 'from').then((data) => {
                  let code = data.data.code;
                  let msg = data.data.msg;
                  if (code == 200) {
                    this.org = data.data.data;
                    if(this.org.length > 0) {
                      this.searchData.orgCode = this.org[0].orgCode;
                    }
                    this.loadMessageCategory();
                  } else {
                    this.$message({
                      type: 'info',
                      message: msg
                    });
                  }
    
                }).catch(err => {
                      this.$message.error('网络错误');
                    }
                );
              },
              changeOrg(val) {
                this.categoryData = [];
                this.loadMessageCategory();
              },
            f_categoryId(row, column, cellValue, index) {
              var result ="";
              var that =this;
               if(that.categoryData &&that.categoryData.length>0){
                    that.categoryData.forEach(element => {
                        if(element.categoryId == cellValue){
                            result = element.categoryName;
                        }
                    });
               }
               return result;
            },
            f_scope(row, column, cellValue, index) {
                if(cellValue == "1") {
                    return "所有注册用户";
                }
                if(cellValue == "2") {
                    return "按课程分类";
                }
                if(cellValue == "3") {
                    return "按课程内容";
                }
                return ""
            },
            f_orgCode(row, column, cellValue, index){
                var result ="";
                var that =this;
                if(that.organizationData && that.organizationData.length>0){
                    that.organizationData.forEach(element => {
                        if(element.orgCode == cellValue){
                            result = element.organizationName;
                        }
                    });
                }
                return result;
            },
            //分页
             handleSizeChange() {
            },
            handleCurrentChange(val) {
                this.search(val);
            },

            handleEdit(index, row) {
                this.showEdit[row.commodityId] = true;
                this.search();
            },
            addMessage() {
                
                this.$router.push({
                    name:"addMessage",
                    params: {"title":"添加消息"}
                });
            },
            dateFormat(row, column, cellValue, index) {
                if(cellValue != null) {
                    return dateFormat(cellValue);
                } else {
                    return cellValue
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = [];
                for(let index in val) {
                    this.multipleSelection[index] =  val[index].messageId;
                }
            },
            updateMessage(row) {
                this.$router.push({
                    name: "addMessage",
                    params: row
                });
            },
            sendMessageToStudent(row) {
                this.$router.push({
                    name: 'MessageStudentList',
                    params: row
                });
            },
            deleteMessageMore() {
                let length = this.multipleSelection.length;
                this.$confirm('此操作将删除'+length+'条消息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let multipleSelection = this.multipleSelection;                  
                    let params = {"messageIdList":multipleSelection};
                    https.fetchPost('/webMessage/deleteMessage',params , "json").then((data) => {
                        let code = data.data.code;
                        let msg = data.data.msg;
                        if(code == '200') {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.search();
                        } else {
                            this.$message({
                                type: 'info',
                                message: '删除失败：'+msg
                            });
                        }
                    }).catch(err=>{
                            this.$message.error('网络异常！');
                        }
                    )

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            deleteMessage(index, row) {
                //deleteIsRecommendByCommodityId
                this.$confirm('此操作将删除该消息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params ={"messageIdList":[]};
                    params.messageIdList.push(row.messageId);
                    https.fetchPost('/webMessage/deleteMessage',params , "json").then((data) => {
                        let code = data.data.code;
                        let msg = data.data.msg;
                        if(code == '200') {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.search();
                        } else {
                            this.$message({
                                type: 'info',
                                message: '删除失败：'+msg
                            });
                        }
                    }).catch(err=>{
                            this.$message.error('网络异常！');
                        }
                    )

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            monthFormat(row, column, cellValue, index) {
                if(cellValue != null) {
                    return monthFormat(cellValue);
                } else {
                    return cellValue
                }
            },
            search(val) {
                this.searchData.size = this.pageSize;
                if(val) {
                    this.searchData.page = val;
                } else {
                    this.searchData.page = 1;
                    this.currentPage = 1;
                }
                let params = this.searchData;
                https.fetchPost('/webMessage/list',params, "json" ).then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if(code == 200) {
                        this.messageData = data.data.data.list;
                        this.total = data.data.data.total
                    } else {
                        this.$message({
                            type: 'info',
                            message: msg
                        });
                    }

                }).catch(err=>{
                        console.log(err)
                    }
                )             
            },
            loadMessageCategory() {
                let params = {
                  orgCode: this.searchData.orgCode
                };
                https.fetchPost('/webMessageCategory/list',params, "json" ).then((data) => {
                    let code = data.data.code;
                    if(code == 200) {
                        let d = data.data.data
                        for(let index in d) {
                            this.categoryData.push(d[index]);
                        }
                    } else {
                        this.$message({
                            type: 'info',
                            message: '加载失败'+msg
                        });
                    }

                }).catch(err=>{
                        this.$message.error('网络错误');
                    }
                )
            },
             loadOrganization() {
                let params = {};
                https.fetchGet('/managerOrganization/getOrganizationList',params, "from" ).then((data) => {
                    let code = data.data.code;
                    if(code == 200) {
                        let d = data.data.data
                        for(let index in d) {
                            this.organizationData.push(d[index]);
                        }
                    } else {
                        this.$message({
                            type: 'info',
                            message: '加载失败'+msg
                        });
                    }

                }).catch(err=>{
                        this.$message.error('网络错误');
                    }
                )
            },
            changeCourse(val) {
                //this.searchData.categoryId = '';
            }
        },
        created: function () {
          this.orgType = this.$store.state.orgType;
          this.searchData.orgCode = this.$store.state.orgCode;
          this.loadMessageCategory();
          this.loadOrganization();
          this.search();
            
        }
    }
</script>

<style scoped>
    .but-cls {
        margin-bottom: 10px;
    }
    .line {
        text-align: center;
    }
    .edit-cell {
        width: 60%;
    }
    .cls-col {
    margin-right: 20px;
}
</style>